export default __webpack_public_path__ + "static/media/1805.9ca4b3dc.png";